import { atomWithReset } from 'jotai/utils';

import { IContactCustom } from '@/src/ContactsModule/interfaces/CustomFieldsInterfaces';

/**
 * @desc Atom of custom fields
 */
export const atomContactCustomFields = atomWithReset<IContactCustom | null>(null);
atomContactCustomFields.debugLabel = 'atomContactCustomFields';
